// extracted by mini-css-extract-plugin
export default {"jobContent":"JobDetails_jobContent__smb0U","backButtonWrapper":"JobDetails_backButtonWrapper__nw7ih","backButton":"JobDetails_backButton__H+QBX"};